export default __webpack_public_path__ + "static/media/four.fc51a179.jpg";